const baseUrl = '/tags';
export const tagsRoutes = {
  baseUrl: "".concat(baseUrl),
  bulkGet: "".concat(baseUrl, "/bulk-get"),
  tagsById: tagId => "".concat(baseUrl, "/").concat(tagId),
  assignTagsToAccount: companyId => "companies/".concat(companyId).concat(baseUrl),
  removeTagsFromAccount: companyId => "companies/".concat(companyId).concat(baseUrl, "/bulk-delete")
};